import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'pile-foundation';
// Fixed slots: img[0]=portrait beside stat boxes, img[1]=square beside circles, img[2]=landscape strip below circles
// Additional: img[3+]

const STATS = [
  { num: '300–1200mm', label: 'Pile Diameter Range' },
  { num: '30m+', label: 'Maximum Pile Depth' },
  { num: 'M25–M45', label: 'Concrete Grade' },
];

const PileFoundation = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="pf-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        {/* Intro text + stat boxes + img[0] rig portrait — 3-col only if image uploaded */}
        {imgs[0] ? (
          <div className="pf-intro">
            <div className="pf-intro-text">
              <h2>About {data.title}</h2>
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="pf-stat-boxes">
              {STATS.map((s) => (
                <div className="pf-stat" key={s.label}>
                  <div className="pf-stat-num">{s.num}</div>
                  <div className="pf-stat-label">{s.label}</div>
                </div>
              ))}
            </div>
            <div className="pf-rig-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="pf-intro-no-img">
            <div className="pf-intro-text">
              <h2>About {data.title}</h2>
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="pf-stat-boxes">
              {STATS.map((s) => (
                <div className="pf-stat" key={s.label}>
                  <div className="pf-stat-num">{s.num}</div>
                  <div className="pf-stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Process circles with img[1] cage image on left — only if image uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          imgs[1] ? (
            <div className="pf-process-wrap">
              <div className="pf-cage-img">
                <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
              </div>
              <div className="pf-process">
                <h2>{data.processTitle}</h2>
                <div className="pf-circles">
                  {data.processSteps.map((s) => (
                    <div className="pf-circle-item" key={s.step}>
                      <div className="pf-circle">{s.step}</div>
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="pf-process-solo">
              <h2>{data.processTitle}</h2>
              <div className="pf-circles">
                {data.processSteps.map((s) => (
                  <div className="pf-circle-item" key={s.step}>
                    <div className="pf-circle">{s.step}</div>
                    <h4>{s.title}</h4>
                    <p>{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )
        )}

        {/* img[2]: completed piles landscape strip — only if uploaded */}
        {imgs[2] && (
          <div className="pf-completed-strip">
            <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
          </div>
        )}

        {data.features && data.features.length > 0 && (
          <div className="pf-feats">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="pf-feat" key={f.title}>
                <div className="pf-feat-icon">{f.icon}</div>
                <div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="pf-specs">
            <h2>{data.specsTitle}</h2>
            <div className="pf-specs-cols">
              {data.specs.map((row, i) => (
                <div className="pf-spec-item" key={i}>
                  <div className="pf-spec-label">{row[0]}</div>
                  <div className="pf-spec-value">{row[1]}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {imgs.length > 3 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(3).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default PileFoundation;
